if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);

      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: `.swiper-button-next-${this.sectionId}`,
        prevEl: `.swiper-button-prev-${this.sectionId}`,
      };

      // Fallback for general classes if specific one not found
      if (!this.section.querySelector(this.selectors.nextEl)) {
        this.selectors.nextEl = '.swiper-button-next';
        this.selectors.prevEl = '.swiper-button-prev';
      }

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile && this.dataset.mobileCarousel !== 'true') {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;

      const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
      let spaceBetween = 8;
      if (columnGap) {
        if (columnGap.includes('px')) {
          spaceBetween = parseFloat(columnGap);
        } else if (columnGap.includes('rem')) {
          spaceBetween = parseFloat(columnGap) * 10;
        }
      }

      const fixedSlideWidth = this.dataset.slideWidth === 'true';
      const desktopSlidesPerView = this.dataset.columnsDesktop
        ? parseInt(this.dataset.columnsDesktop)
        : 'auto';
      const mobileSlidesPerView = fixedSlideWidth
        ? 'auto'
        : this.dataset.columnsMobile
        ? parseFloat(this.dataset.columnsMobile)
        : desktopSlidesPerView;

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Scrollbar].filter(m => typeof m === 'function'),
        slidesPerView: mobileSlidesPerView,
        spaceBetween: spaceBetween,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        pagination: false,
        loop: false,
        threshold: 2,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: desktopSlidesPerView,
            spaceBetween: spaceBetween,
          },
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}
